import { render, staticRenderFns } from "./recovery_password.vue?vue&type=template&id=2b5aa46a&scoped=true"
import script from "./recovery_password.vue?vue&type=script&lang=js"
export * from "./recovery_password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5aa46a",
  null
  
)

export default component.exports